module.exports = __webpack_public_path__ + "static/media/road-h.85fbbf7c.jpg";